/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, serializeInvoiceDto, serializeVoidInvoiceRequest, type ErrorResponse, type InternalErrorResponse, type InvoiceDto, type VoidInvoiceRequest } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/{invoiceId}/void
 */
export interface VoidRequestBuilder extends BaseRequestBuilder<VoidRequestBuilder> {
    /**
     * Writes an invoice off as no longer collectible. Any status can be voided — draft, issued, partially paid or paid — but only while nothing is currently paid against it: refund every settled payment first, or the call is refused. Voided is terminal, so the invoice cannot be issued, paid or reopened afterwards, and it stops counting toward its order's invoiced quantities and totals. Unlike the other lifecycle calls this one is idempotent: voiding an invoice that is already voided or cancelled returns it unchanged rather than failing.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: VoidInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto | undefined>;
    /**
     * Writes an invoice off as no longer collectible. Any status can be voided — draft, issued, partially paid or paid — but only while nothing is currently paid against it: refund every settled payment first, or the call is refused. Voided is terminal, so the invoice cannot be issued, paid or reopened afterwards, and it stops counting toward its order's invoiced quantities and totals. Unlike the other lifecycle calls this one is idempotent: voiding an invoice that is already voided or cancelled returns it unchanged rather than failing.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: VoidInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const VoidRequestBuilderUriTemplate = "{+baseurl}/api/invoices/{invoiceId}/void";
/**
 * Metadata for all the requests in the request builder.
 */
export const VoidRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: VoidRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeVoidInvoiceRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
